export default __webpack_public_path__ + "static/Poppins-Italic-3a07eab52bc91374d82cd9f1828dab75.woff2";